import type { IconData } from '@stacksjs/iconify-core'

export const module: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M3.688 36.278c.163 1.164.912 2.131 1.972 2.638C9.474 40.741 18.922 45 24 45s14.526-4.26 18.34-6.084c1.06-.507 1.809-1.474 1.972-2.638C44.605 34.18 45 30.204 45 24s-.395-10.18-.688-12.278c-.163-1.164-.912-2.131-1.972-2.638C38.526 7.259 29.078 3 24 3S9.474 7.26 5.66 9.084c-1.06.507-1.809 1.474-1.972 2.638C3.395 13.82 3 17.796 3 24s.395 10.18.688 12.278Z\"/><path stroke-linecap=\"round\" d=\"M44.281 11.756C41.033 13.356 27.714 19.8 24 19.8c-3.715 0-17.034-6.445-20.282-8.044M24 19.8v24.95\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default module
